
const digest = '80ad2f51a1200aff763de6daa0d7aa7831ee3f7f7b204d874dee05df992b6bdc';
const classes = {"pillButton":"_pillButton_14swr_1","pill":"_pill_14swr_1","loadingWrapper":"_loadingWrapper_14swr_9"};
const css = `._pillButton_14swr_1 ._pill_14swr_1 {
  height: 22px;
  width: 60px;
  position: absolute;
  z-index: 1;
  margin-left: 25px;
}

._loadingWrapper_14swr_9 {
  display: flex;
  justify-content: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  